import React, { useEffect, useRef, useState } from 'react';
import {
  GETQUICKCOMBO,
  GETQUICKITEMS,
  isEmpty,
  printDebugLog,
  SUCCESS
} from "../../../constants/constant";
import { Autocomplete,  FormControl,  FormControlLabel,  FormLabel,  Grid, IconButton, InputAdornment, Paper, Radio, RadioGroup, TextField } from '../../ui';
import { snpAxios } from '../../global/api';
import uiUtilInstance from '../../../utilities/uiUtil';
import AddIcon from '../../ui/icons/Add';
import RemoveIcon from '../../ui/icons/Remove';
//import SnpButton from '../../global/SnpButton';

const RenderItemSearch = ({ isPaid, baseUrl = "",shopHashId,
    encodedHash = "", columnList, handleUpdateColumn,fireSnackBarMsg}) => {

    const [inputValue, setInputValue] = useState('');
    const [listFoodItems, setListFoodItem] = useState([]);
    const [selectedItem, setSelectedItem] = useState({});
    const [quantity, setQuantity] = useState("");
    const [pQuantity, setPQuantity] = useState(0);

    const autoRef = useRef(null);
    const quantityRef = useRef(null);
    const colQuantityClasses = uiUtilInstance.useStyles();
    const [isCombo,setCombo] = useState(false);


    const fetchQuickItems = async (regextStr, mode) => {
        try {
            const fetchBillUrl = `${baseUrl}${GETQUICKITEMS}?s=${encodedHash}&q=${regextStr}&m=${mode}`;
            const response = await snpAxios.get(fetchBillUrl);
            if (response.data.status === SUCCESS) {
                setListFoodItem(response.data.jcJson.value_2);
            }
        } catch (e) {
            console.error("fetchQuickItems", e);
        }
    };

    const fetchComboItems = async (regextStr) => {
        try {
            const fetchBillUrl = `${baseUrl}${GETQUICKCOMBO}?s=${shopHashId}&q=${regextStr}&itemStatus=1`;
            const response = await snpAxios.get(fetchBillUrl);
            if (response.data.status === SUCCESS) {
                setListFoodItem(response.data.jcJson.value_2);
            }
        } catch (e) {
            console.error("fetchQuickItems", e);
        }
    };

    useEffect(() => {
        autoRef.current?.focus();
    }, []);

    const handleQuickItemsSearch = (event, mode) => {
        const value = event.target.value;
        if (value.length >= 3) {
            if (isCombo) {
                fetchComboItems(value);
            } else {
                fetchQuickItems(value, mode);
            }
            
        }
    };

    const handleInputChange = (event) => {
        if (event) {
            setInputValue(event.target.value);
        }
    };

    const handleSelectItems = (ev, option) => {
        printDebugLog("handleSelectItems", ev?.key, option);
        setSelectedItem(option);
        if (option) {
            const index = columnList.findIndex(singleValue => singleValue.prdId === option.id);
            if (index > -1) {
                setPQuantity(columnList[index].quantity);
                setQuantity(columnList[index].quantity);
            }
            setInputValue(option.price.details); // show selected item in input
            setTimeout(() => {
                quantityRef.current?.focus(); // move focus to quantity after slight delay
            }, 100);
        } else {
            setInputValue("");
        }
    };

    const handleIncrement = () => {
        if (isPaid) {
            fireSnackBarMsg({msg: "Bill already paid",mColor: "#e41616"});
            return;
        }
        setQuantity((prev) => prev + 1);
    }

    const handleDecrement = () => {
        if (isPaid) {
            fireSnackBarMsg({msg: "Bill already paid",mColor: "#e41616"});
            return;
        }
        setQuantity((prev) => Math.max(1, prev - 1)); // Avoid 0 or negative
    };

    const handleQuantityKeyPress = (e) => {
        //printDebugLog("handleQuantityKeyPress",e.key);
        if (isPaid) {
            return;
        } else {
            if (e.key === "+") {
                handleIncrement();
            } else if (e.key === "-") {
                handleDecrement();
            } else if (e.key === "Enter" ) {
                // Call your save method here
                if (isEmpty(inputValue)) {
                    uiUtilInstance.hideKeyBoard();
                    fireSnackBarMsg({msg: "Please add product",mColor: "#e41616"});
                } else {
                    if (isEmpty(quantity)) {
                        handleUpdateColumn(selectedItem, 1);
                    } else {
                        const mQuantity = (Number(pQuantity) === Number(quantity)) ? Number(quantity) + 1 : Number(quantity);
                        handleUpdateColumn(selectedItem, mQuantity);
                    }
                    setPQuantity(0);
                    setQuantity(""); // Reset quantity
                    setInputValue("");
                    setSelectedItem({});
                }
                // Re-focus to quick-select
                autoRef.current?.focus();
            }
        }
    };

    // const handleColumnUpdate = () => {
    //     if (isPaid) {
    //         return;
    //     } else {
    //         if (isEmpty(quantity)) {
    //             handleUpdateColumn(selectedItem, 1);
    //         } else {
    //             handleUpdateColumn(selectedItem, quantity);
    //         }
    //         setQuantity(1); // Reset quantity
    //         setInputValue("");
    //         setSelectedItem({});
    //         // Re-focus to quick-select
    //         autoRef.current?.focus();
    //     }
    // }

    const handleColQuantityChange = (event) => {
        //printDebugLog("handleColQuantityChange => ", event.target.value);
        const value = event.target.value;
        if (value === '' || /^\d*\.?\d*$/.test(value)) {
            setQuantity(value);
        }        
    }
    

    useEffect(() => {
        autoRef.current?.focus();
        const handleKeyDown = (event) => {
            //printDebugLog("handleKeyDown",event);
            if (event.ctrlKey && event.key === '1') {
                event.preventDefault();
                setCombo(prev=>!prev);
            } else if (event.ctrlKey && event.key === '2') {
                event.preventDefault();
                setInputValue("");
                setSelectedItem({});
                autoRef.current?.focus();
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    return (
        <Grid item xs={12}>
            <Paper elevation={0}
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    backgroundColor: "#d3fdf3",
                    boxShadow: 1,
                    borderRadius: 5,
                    padding: 1,
                }} >
                <Grid container spacing={3} alignItems="flex-end">
                    <Grid item xs={12}>
                        <FormControl component="fieldset">
                            <FormLabel component="legend">Select{uiUtilInstance.showHotKeySpan("ctrl+1")}</FormLabel>
                            <RadioGroup row aria-label="isCombo" name="isCombo" value={isCombo} onChange={(e)=> setCombo(prev=> !prev) }>
                                <FormControlLabel value={false} control={<Radio />} label="Search By Item" />
                                <FormControlLabel value={true} control={<Radio />} label="Search by Combo" />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                        <Autocomplete id="quick-select"
                            options={listFoodItems}
                            autoHighlight
                            variant="filled"
                            fullWidth
                            onChange={handleSelectItems}
                            onInputChange={handleInputChange}
                            onBlur={() => setListFoodItem([])}
                            disabled={isPaid}
                            getOptionLabel={(option) => option.id}
                            filterOptions={(options, { inputValue }) =>
                                options.filter((option) =>
                                    option?.name?.toLowerCase().includes(inputValue?.toLowerCase())||
                                    option?.price.details?.toLowerCase().includes(inputValue?.toLowerCase())
                                )
                            }
                            inputValue={inputValue}
                            renderOption={(props, option) => (
                                uiUtilInstance.displaySearchedRestoProductItem(option,props,baseUrl)
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={uiUtilInstance.showHotKeySpanWithText("ctrl+2","Search Product Item")}
                                    inputRef={autoRef}
                                    onChange={(e) => handleQuickItemsSearch(e, 1)}
                                    inputProps={{
                                        ...params.inputProps,
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} sx={{ display: 'flex', alignItems: 'flex-end' }}>
                        <TextField
                            id="colQuantity"
                            name="colQuantity"
                            className={colQuantityClasses.input}
                            value={quantity}
                            inputRef={quantityRef}
                            onKeyDown={handleQuantityKeyPress}
                            type="search"
                            disabled={isPaid}
                            helperText={<span style={{whiteSpace: 'pre-wrap',
                                overflowWrap: 'break-word'}}>{"Enter Quantity(Use keyboard '+' to increment '-' to decrement"}</span>}
                            inputMode="numeric"
                            variant="standard"
                            size="small"
                            sx={{
                                justifyContent: "end",
                                alignContent: "end",
                                '& .UiInputBase-input': {
                                    textAlign: "center",
                                },
                                '& input[type="search"]::-webkit-search-cancel-button': {
                                    display: 'none',
                                },
                            }}
                            onChange={handleColQuantityChange}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <IconButton onPointerDown={handleIncrement}>
                                            <AddIcon color="success" sx={{
                                                fontSize: "2rem",
                                            }}  />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onPointerDown={handleDecrement}>
                                            <RemoveIcon color="warning" sx={{
                                                fontSize: "2rem",
                                            }}  />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Grid>
                    {/* <Grid item xs={12} sm={6} sx={{ display: { xs: 'block', sm: 'block', md: 'none', lg: 'none' } }}>
                        <SnpButton variant="contained"
                            mbgcolor="#ca241e"
                            mpadding="1px"
                            disableRipple
                            sx={{
                                WebkitTapHighlightColor: 'transparent',
                                transition: 'background-color 0.2s ease',
                                cursor: "pointer"
                            }}
                            onPointerDown={() => handleColumnUpdate()}
                        >Search</SnpButton>
                    </Grid> */}
                </Grid>
            </Paper>
        </Grid>
    )
};

export default React.memo(RenderItemSearch);


// const handleAutoKeyPress = (e,option) => {
        
    //     if (e.key === "Enter") {
    //         printDebugLog("handleAutoKeyPress",e.target.value , option);
    //         const match = listFoodItems.find(
    //             (item) => item.price.details.toLowerCase() === inputValue.toLowerCase()
    //           );
    //           if (match) {
    //             handleSelectItems(e, match); // simulate selection
    //             setInputValue(match.price.details); // show selected item in input
    //             setTimeout(() => {
    //               quantityRef.current?.focus(); // move focus to quantity after slight delay
    //             }, 100);
    //           }
    //     }
    // };